import React, { useState } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { useTranslation } from 'react-i18next';
import './CustomerReview.css';

const CustomerClinicReview = ({ clinicId, customerToken }) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState('');
  const [feeling, setFeeling] = useState('');
  const [comment, setComment] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [message, setMessage] = useState('');

  const submitReview = async () => {
    if (!rating || !feeling) {
      setMessage(t('review_fill_all_fields'));
      return;
    }

    // Require employee name if feedback is negative
    if (feeling === 'negative' && employeeName.trim() === '') {
      setMessage(t('review_provide_employee_name'));
      return;
    }

    try {
      await addDoc(collection(db, 'clinic_reviews'), {
        clinic_id: clinicId,
        customer_token: customerToken,
        rating,
        feeling,
        comment,
        reported_employee: employeeName || null,
        timestamp: Timestamp.now(),
      });

      setMessage(t('review_success'));
      setRating('');
      setFeeling('');
      setComment('');
      setEmployeeName('');
    } catch (error) {
      setMessage(t('review_error') + ': ' + error.message);
    }
  };

  return (
    <div className="review-container">
      <h3 className="review-title">{t('leave_review')}</h3>

      <select value={rating} onChange={(e) => setRating(e.target.value)} required>
        <option value="">{t('review_select_rating')}</option>
        <option value="bad">😞 {t('review_rating_bad')}</option>
        <option value="good">🙂 {t('review_rating_good')}</option>
        <option value="very good">😊 {t('review_rating_very_good')}</option>
        <option value="excellent">🌟 {t('review_rating_excellent')}</option>
      </select>

      <select value={feeling} onChange={(e) => setFeeling(e.target.value)} required>
        <option value="">{t('review_select_feeling')}</option>
        <option value="positive">😄 {t('review_feeling_positive')}</option>
        <option value="negative">😠 {t('review_feeling_negative')}</option>
        <option value="neutral">😐 {t('review_feeling_neutral')}</option>
      </select>

      {feeling === 'negative' && (
        <input
          type="text"
          className="clinic-review-employee"
          placeholder={t('review_employee_name_placeholder')}
          value={employeeName}
          onChange={(e) => setEmployeeName(e.target.value)}
        />
      )}

      <textarea
        placeholder={t('review_comment_placeholder')}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      ></textarea>

      <button className="submit-btn" onClick={submitReview}>
        {t('review_submit_button')}
      </button>

      {message && <div className="review-message">{message}</div>}
    </div>
  );
};

export default CustomerClinicReview;